import Column from '@components/Column';
import styled from '@emotion/styled';
import { UserCouponResponse } from '@models/coupon';
import { ReactNode } from 'react';

import CouponImageCard from './CouponImageCard';
import CouponText from './CouponText';

interface Props {
    coupon: UserCouponResponse;
    /** 구분선 아래에 붙는 영역(바코드) */
    children?: ReactNode;
}

function CouponInfo({ coupon, children }:Props) {
    return (
        <Container fullWidth align='center' spacing={4}>
            <CouponImageCard coupon={coupon}/>
            <CouponText coupon={coupon} />
            {children && (
                <>
                    <Divider/>
                    {children}
                </>
            )}
        </Container>
    );
}

const Container = styled(Column)`
    padding: var(--spacing-6);
`;

const Divider = styled.div`
    background-color: var(--color-border-default);
    height: 1px;
    width: 100%;
`;

export default CouponInfo;
